import vars from '../../common/vars';
import { MAC_DESKTOP_OS } from '../../common/constants/desktop';

export default function loadGa(desktopOS) {
  let propertyId = vars.get('GA_PROPERTY_ID');

  if (desktopOS) {
    propertyId = vars.get(
      desktopOS === MAC_DESKTOP_OS
        ? 'GA_PROPERTY_ID_MAC_DESKTOP'
        : 'GA_PROPERTY_ID_WINDOWS_DESKTOP',
    );
  }

  if (propertyId) {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
    /*eslint-disable */
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga('create', propertyId, 'auto');
    ga('send', 'pageview'); // needs to be called for the current page

    // global tag script
    // https://support.google.com/google-ads/answer/7548399?hl=en
    (function (w, d, s, l, i) {
      w.dataLayer = w.dataLayer || [];
      w.gtag = w.gtag || function () { dataLayer.push(arguments) };

      gtag('js', new Date());
      gtag('config', propertyId);
      gtag('config', `AW-${vars.get('G_ADWORDS_CONVERSION_ID')}`);

      // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
      w.gtagPageChange = (path) => {
        gtag('config', propertyId, { page_path: path });
      }

      const c = d.createElement(s);
      const el = d.getElementsByTagName(s)[0];
      c.async = true;
      c.src = `${l}?id=${propertyId}`;
      el.parentNode.insertBefore(c, el);
    })(window, document, 'script', 'https://www.googletagmanager.com/gtag/js');
    /* eslint-enable */
  }
}
